module.exports = __webpack_public_path__ + "static/img/logo.1110f6c5.png";